import type { AppRoute } from "@/lib/routing";
import { PublishedFormulasPage } from "./PublishedFormulasPage";

export const routes: AppRoute[] = [
  {
    path: "/published-formulas",
    element: <PublishedFormulasPage />,
    handle: {
      title: "Published formulas",
      keywords: ["demo formulas", "Fraterworks", "smells like", "reconstructions", "library"],
    },
  },
  {
    path: "/published-formulas/:id",
    lazy: async () => ({ Component: (await import("./PublishedFormulaPage")).PublishedFormulaPage }),
    handle: { title: "Published formula" },
  },
];
